import { Component, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    MatSnackBarModule
  ],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent {
  translate = inject(TranslateService);
  fb = inject(FormBuilder);
  contactForm = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    message: ['', Validators.required],
  });

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {}

  onSubmit() {
    const url = `${environment.apiBaseUrl}/contact`;
  
    if (this.contactForm.valid) {
      this.http.post(url, this.contactForm.value).subscribe({
        next: () => {
          this.snackBar.open(
            this.translate.instant('CONTACT.SUCCESS'),
            this.translate.instant('CONTACT.CLOSE'),
            { duration: 3000 }
          );
          this.contactForm.reset();
        },
        error: () => {
          this.snackBar.open(
            this.translate.instant('CONTACT.ERROR'),
            this.translate.instant('CONTACT.CLOSE'),
            { duration: 3000 }
          );
        },
      });
    }
  }
  
}
